import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>InspiraPix</h3>
          <p>Your source for creative inspiration and amazing artworks.</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/explore">Explore</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Categories</h4>
          <ul>
            <li><Link to="/explore?category=Digital Art">Digital Art</Link></li>
            <li><Link to="/explore?category=Photography">Photography</Link></li>
            <li><Link to="/explore?category=Illustration">Illustration</Link></li>
            <li><Link to="/explore?category=AI Generated">AI Art</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://x.com/inspira_pix" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            <li><a href="https://www.pinterest.com/inspirapix/" target="_blank" rel="noopener noreferrer">Pinterest</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 InspiraPix. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 